import { Lumber, LumberPropertySet, LumberSet, LumberWithStockLengths } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getLatestCalculationPropertySet(lumber: Lumber): Promise<LumberPropertySet | null> {
  return DesignService.post(`lumbers/latestCalculationPropertySet`, { data: lumber });
}

export function getDefaultLumberInventory() {
  return DesignService.get<readonly Lumber[]>('lumbers/getDefaultLumberInventory');
}

export type ExpandedLumberSet = {
  readonly allowedLumbers: readonly LumberWithStockLengths[];
  readonly disallowedLumbers: readonly LumberWithStockLengths[];
};
export function expandLumberSet(lumberSet: LumberSet): Promise<ExpandedLumberSet> {
  return DesignService.post('lumbers/expandLumberSet', { data: lumberSet });
}
